import { Http } from '../axios/interceptors'


export const allCatalogs = async (param) => Http('GET', `/Catalogs/GetList?`, param)

export const getCatalog = async (param) => Http('GET', `/Catalogs/Get?`, param)

export const createOrEditCatalog = async (body, id = null) => (id ? Http('PUT', `/Catalogs/Update`, null, body) : Http('POST', '/Catalogs/Create', null, body))

export const deleteCatalog = async guid => Http('DELETE', `/Catalogs/Delete?guidCatalog=${guid}`)

export const addItemCatalog = async (body) => (Http('PUT', '/Catalogs/AddItem', null, body))

export const editItemCatalog = async (body) => (Http('PUT', `/Catalogs/UpdateItem`, null, body) )

export const deleteItemCatalog = async (param) => Http('DELETE', `/Catalogs/DeleteItem?`, param)

export const getDolarToday = async () => Http('POST', `/DolarYadio/QueryDollar?usd=1`)
export const getDolarBcv= async () => Http('POST', `/DolarYadio/QueryDollarBCV?usd=1`)

// ---------------------------------- Catalogs

export const getCat = async guid => Http('GET', `/Catalogs/Get?guidCatalog=${guid}&itemsPage=1&itemsRows=1000`)


export const postFile = async (image = null) => {
  const formData = new FormData()

  formData.append('file', image)

  return Http('POST', '/Files/Upload', null, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const postFileDocument = async (document = null) => {
  const formData = new FormData()

  formData.append('file', document)

  return Http('POST', 'Files/UploadPDF?question=document', null, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

// const config = {
//     method: 'get',
//     type: 'text',
//     payload: undefined,
//     payloadType: 'json',
// };
// const defaultFetchOptions = {
//     method: config.method,
//     headers: {},
// };
// if (config.payload) {
//     const headers = defaultFetchOptions.headers;
//     if (config.payloadType === 'json') {
//         defaultFetchOptions.body = JSON.stringify(config.payload);
//         headers['Content-Type'] = 'application/json';
//     }
//     else {
//         defaultFetchOptions.body = config.payload;
//         headers['Content-Type'] = config.payloadType === 'formData'
//             ? 'multipart/form-data'
//             : 'text/plain';
//     }
// }